<div [ngClass]="{'row':true, 'row_main': true}">

  @if(!esEmpresaEnUnDia) {
    <!-- propuesta simulación -->
    @if(step == 1){
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">

        <div style="margin-top: 30px;">
          <div class="titulo" style="margin-bottom: 10px;">te damos la bienvenida a Simpli</div>
        </div>

        <mat-card class="centerabsolute margin-mobile" style="max-width: 680px;">

          <mat-card-content>
            <div class="mat-container">
              <div class="icon">
                <span class="material-symbols-outlined">error</span>
              </div>

              <div class="titulo-card">
                solo nos falta generar tu contrato de factoring para continuar
              </div>

              <div class="box-info">
                <div>Carga los <strong>documentos de tu empresa</strong> para que nuestra área legal pueda elaborar tu
                contrato.
              </div>
            </div>

            <div class="lista">
              <span class="titulo-lista">Documentos que debes cargar:
                <ul>
                  <li>Extracto de la escritura de constitución.</li>
                  <li>Última declaración jurada.</li>
                  <li>Copia de la inscripción de constitución de sociedad.</li>
                  <li>Certificado de Vigencia de la sociedad.</li>
                  <li>Publicación en Diario Oficial.</li>
                  <li>Protocolización.</li>
                </ul>
              </span>
            </div>

            <div class="subtitulo-card">
              Si necesitas <strong>reunir los documentos</strong>, puedes continuar el proceso más tarde.
            </div>

            <div class="caja-botones">
              <button mat-stroked-button class="primary-button" (click)="open_modal_info(25)">Cargar documentos</button>
              <button mat-stroked-button class="secondary-button" (click)="step = 5">Continuar más tarde</button>
            </div>

            <div class="footer-botones">
              <span (click)="open_modal_info(22)">Revisa la descripción de cada documento</span>
            </div>
          </div>
        </mat-card-content>

      </mat-card>

    </div>
  }

  <!-- carga los documentos legales/Input -->
  @if(step == 2){
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
      <div style="margin-top: 60px;"></div>

      <mat-card class="centerabsolute margin-mobile" style="max-width: 680px;">
        <mat-card-content>
          <div class="mat-container">
            <div class="titulo-card">carga los documentos de tu empresa</div>
            <div class="subtitulo-card">Solo se admiten los formatos <strong>PDF</strong>, <strong>JPG</strong> y
            <strong>PNG</strong>
          </div>
        </div>

        <div class="documentos-container">
          @for (documento of documentos; track documento) {
            <div class="documento-item">
              <div class="documento-input-container">
                <div class="documento-label-container">
                  <input type="file" [id]="documento.id" accept=".pdf,.jpg,.jpeg,.png" hidden
                    (change)="onFileSelected($event, documento)" #fileInput>
                  <label [for]="documento.id" class="full-label">
                    <div class="documento-nombre">
                      @if (!documento.archivo) {
                        <span>{{ documento.nombre }}</span>
                      }
                      @if (documento.archivo) {
                        <span class="file-uploaded">
                          <span class="material-symbols-outlined">check</span> {{ documento.nombreArchivo }}
                        </span>
                      }
                    </div>
                  </label>
                </div>
                <div class="action-button">
                  @if (!documento.archivo) {
                    <label [for]="documento.id" class="upload-button">
                      <span class="material-symbols-outlined">attach_file</span>
                    </label>
                  }
                  @if (documento.archivo) {
                    <button class="delete-button" (click)="deleteFile(documento)">
                      <span class="material-symbols-outlined">delete_forever</span>
                    </button>
                  }
                </div>
              </div>
              <div class="input-underline"></div>
              <div class="file-info">
                @if (!documento.archivo && !documento.error) {
                  <span class="file-placeholder">
                    Agrega el archivo desde tu equipo o dispositivo
                  </span>
                }
                @if (documento.archivo) {
                  <span class="file-placeholder">
                    {{ documento.nombre }}
                  </span>
                }
                @if (documento.error) {
                  <span class="file-error">
                    {{ documento.error }}
                  </span>
                }
              </div>
            </div>
          }
        </div>



        <div class="caja-botones">
          <button mat-stroked-button class="primary-button" [disabled]="!allDocumentsUploaded()"
          (click)="finalizarCarga()">Finalizar carga</button>
        </div>

        <div class="footer-botones">
          <span (click)="step = 3">Prefiero realizar una carga masiva</span>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
}

<!-- carga masiva -->
@if(step == 3){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <div style="margin-top: 60px;"></div>
    <mat-card class="centerabsolute margin-mobile" style="max-width: 680px;">
      <mat-card-content>
        <div class="mat-container">
          <div class="imagen-final">
            <img src="../../assets/iconografia/Iconografia - Upload file.png" style="height: 160px !important;">
          </div>
          <div class="titulo-card">agrega los documentos desde tu equipo o dispositivo</div>
          <div class="subtitulo-card">Solo se admiten los formatos <strong>PDF</strong>, <strong>JPG</strong> y
          <strong>PNG</strong>
        </div>

        <div class="lista" style="margin-top: 15px;">
          <span class="titulo-lista">Documentos que debes cargar:
            <ul>
              <li>Escritura de constitución de la sociedad</li>
              <li>Extracto de la escritura de constitución</li>
              <li>Copia de la inscripción de constitución de sociedad</li>
              <li>Certificado de Vigencia de la sociedad</li>
              <li>Publicación en Diario Oficial</li>
              <li>Protocolización</li>
            </ul>
          </span>
        </div>

        <div class="upload-container">
          <div class="dropzone" [class.has-files]="uploadedFiles.length > 0" [class.dragover]="isDragOver"
            (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onFileDrop($event)">

            @if (uploadedFiles.length === 0) {
              <div class="agregar-archivo" (click)="triggerFileInput()">
                <div class="icon-agregar">
                  <span class="material-symbols-outlined">add_circle</span>
                </div>
                <div class="text-agregar">
                  <div class="titulo2">Agregar archivo</div>
                  <div class="subtitulo2">o arrastra y suelta los archivos aquí</div>
                </div>
              </div>
            }

            @if (uploadedFiles.length > 0) {
              <div class="lista-archivos">
                @for (file of uploadedFiles; track file) {
                  <div class="file-item">
                    <span class="file-name">
                      <div class="container-svg">
                        @if (isImageFile(file)) {
                          <span class="material-symbols-outlined" style="color:#A067E6">flip</span>
                        }
                        @if (isPdfFile(file)) {
                          <img src="../../../assets/icon/adobe-icon.png" class="pdf-icon">
                        }
                        @if (!isImageFile(file) && !isPdfFile(file)) {
                          <span class="material-symbols-outlined" style="color:#A067E6">flip</span>
                        }
                      </div>
                      {{ file.name }}
                    </span>
                    <button class="delete-button" (click)="removeFile(file, $event)">
                      <span class="material-symbols-outlined">delete_forever</span>
                    </button>
                  </div>
                }
              </div>
            }

            <input type="file" id="fileInput" hidden multiple (change)="onFileSelect($event)" #fileInput />
          </div>
        </div>

        @if (uploadedFiles.length === 0) {
          <div class="caja-botones">
            <button mat-stroked-button class="primary-button" (click)="step = 2">
              Volver
            </button>
          </div>
        }

        @if (uploadedFiles.length > 0) {
          <div class="caja-botones">
            <button mat-stroked-button class="primary-button" [disabled]="uploadedFiles.length === 0"
              (click)="finalizarCargaMasiva()">
              Finalizar carga
            </button>
            <button mat-stroked-button class="secondary-button" (click)="fileInput.click()">Agregar más archivo</button>
          </div>
        }

      </div>
    </mat-card-content>
  </mat-card>
</div>
}
<!-- pantalla de espera -->
@if(step == 4){
  <div
    class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn step4-container">
    <div style="margin-top: 60px;"></div>

    <mat-card class="centerabsolute" style="max-width: 680px;">
      <mat-card-content>
        <div class="mat-container">
          <div class="imagen-final">
            <img src="../../assets/iconografia/Iconografia - legal.png" style="height: 160px !important;">
          </div>
          <div class="titulo-card" style="margin-top: 10px;">nuestra área legal está revisando los documentos cargados
          </div>
          <div class="subtitulo-card">Te notificaremos cuando esté todo preparado para avanzar al proceso de firma de
          contrato.</div>

          <div class="caja-botones">
            <button mat-stroked-button class="secondary-button" (click)="logout()">Cerrar sesión</button>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

    <div class="contact-container">
      <contact-container></contact-container>
    </div>

  </div>
}

<!-- continuar más tarde -->
@if(step == 5){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">

    <div style="margin-top: 60px;"></div>

    <mat-card class="centerabsolute margin-mobile" style="max-width: 680px;">

      <mat-card-content>
        <div class="mat-container">
          <div class="icon">
            <span class="material-symbols-outlined">error</span>
          </div>

          <div class="titulo-card">¡Te estaremos esperando!</div>

          <div class="subtitulo-card" style="margin-bottom: 10px;">
            Una vez que reúnas los documentos, regresa aquí para <strong>retomar <br>tu incorporación como
          cliente</strong>.
        </div>


        <div class="caja-botones">
          <button mat-stroked-button class="primary-button" (click)="step = 1">Retomar mi incorporación</button>
          <button mat-stroked-button class="secondary-button" (click)="logout()">Cerrar sesión</button>
        </div>

      </div>
    </mat-card-content>

  </mat-card>

</div>
}
} @else {
  <!-- @if(step == 1){
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 animate__animated animate__faster animate__fadeIn" style="height: 100vh; margin: 0 auto;">
    <div class="imagen-final">
      <img src="../../assets/iconografia/swiper4.svg" style="height: 160px !important;">
    </div>

    <div class="titulo-card" style="margin-top: 10px;">¡nuestra área legal ya está generando tu contrato de factoring!
    </div>
    <div class="subtitulo-card" style="margin-top: 10px;">Una vez que firmes el contrato, podrás continuar con tu
    operación</div>

    <div class="box-info-pink">
      <span class="material-symbols-outlined">draw</span>Te notificaremos cuando esté todo preparado para iniciar el proceso
      de&nbsp;<strong>firma electrónica</strong>
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="secondary-button" (click)="logout()">Cerrar sesión</button>
    </div>

  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 animate__animated animate__faster animate__fadeIn" style="background: navy; height: 100vh;">
  </div>
  } -->

  @if(step == 1){
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn step4-container">

      <div style="margin-top: 30px;">
        <div class="titulo" style="margin-bottom: 10px;">carga los siguientes documentos para agilizar la creación de tu
        contrato</div>
      </div>

      <mat-card class="centerabsolute" style="max-width: 860px;">

        <mat-card-content>
          <div class="mat-container">

            <div class="box-info" style="margin-bottom: 5px">
              <div>
                Nuestra área legal necesita que <strong>agregues y/o actualices</strong> algunos documentos de tu empresa
                para avanzar en la elaboración del contrato de factoring.
              </div>
            </div>

            <div class="subtitulo-card" style="text-align: left !important;">
              <strong>Formatos permitidos:</strong> PDF, JPG y PNG.
            </div>

            <mat-card appearance="outlined" class="avales-card">
              <mat-card-content class="aval-container with-border">
                <div class="name">
                  Cédula del representante legal <strong>Gerardo Villagra</strong>
                </div>
                <div class="carga">
                  <button mat-stroked-button class="uploaded-button"><span class="material-symbols-outlined">check_circle</span> Documento cargado</button>
                  <span class="material-symbols-outlined delete-button">delete_forever</span>
                </div>
              </mat-card-content>

              <mat-card-content class="aval-container with-border">
                <div class="name">
                  Copia de la inscripción de constitución de sociedad
                </div>
                <div class="carga">
                  <button mat-stroked-button class="primary-button"><span class="material-symbols-outlined">attach_file</span> Cargar documento</button>
                </div>
              </mat-card-content>

              <mat-card-content class="aval-container">
                <div class="name">
                  Certificado de Vigencia de la sociedad
                </div>
                <div class="carga">
                  <button mat-stroked-button class="primary-button"><span class="material-symbols-outlined">attach_file</span> Cargar documento</button>
                </div>
              </mat-card-content>
            </mat-card>

            <div class="caja-botones">
              <button mat-stroked-button class="primary-button" (click)="step = 4">Finalizar carga</button>
            </div>

            <div class="footer-botones">
              <span (click)="step = 2">Prefiero realizar una carga masiva</span>
            </div>
          </div>
        </mat-card-content>

      </mat-card>

      <div class="contact-container" style="margin-bottom: 30px;">
        <contact-container></contact-container>
      </div>

    </div>
  }

  @if(step == 2){
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
      <div style="margin-top: 30px;">
      </div>
      <mat-card class="centerabsolute margin-mobile" style="max-width: 700px;">
        <mat-card-content>
          <div class="mat-container">
            <div class="imagen-final">
              <img src="../../assets/iconografia/Iconografia - Upload file.png" style="height: 160px !important;">
            </div>
            <div class="titulo-card">agrega los documentos desde tu equipo o dispositivo</div>
            <div class="subtitulo-card">Solo se admiten los formatos <strong>PDF</strong>, <strong>JPG</strong> y
            <strong>PNG</strong>
          </div>

          <div class="lista" style="margin-top: 20px;">
            <span class="titulo-lista">Documentos que debes cargar:
              <ul>
                <li>Cédula del representante legal <strong>Gerardo Villagra</strong></li>
                <li>Copia de la inscripción de constitución de sociedad</li>
                <li>Certificado de Vigencia de la sociedad</li>
              </ul>
            </span>
          </div>

          <div class="upload-container">
            <div class="dropzone" [class.has-files]="uploadedFiles.length > 0" [class.dragover]="isDragOver"
              (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onFileDrop($event)">

              @if (uploadedFiles.length === 0) {
                <div class="agregar-archivo" (click)="triggerFileInput()">
                  <div class="icon-agregar">
                    <span class="material-symbols-outlined">add_circle</span>
                  </div>
                  <div class="text-agregar">
                    <div class="titulo2">Agregar archivo</div>
                    <div class="subtitulo2">o arrastra y suelta los archivos aquí</div>
                  </div>
                </div>
              }

              @if (uploadedFiles.length > 0) {
                <div class="lista-archivos">
                  @for (file of uploadedFiles; track file) {
                    <div class="file-item">
                      <span class="file-name">
                        <div class="container-svg">
                          @if (isImageFile(file)) {
                            <span class="material-symbols-outlined" style="color:#A067E6">flip</span>
                          }
                          @if (isPdfFile(file)) {
                            <img src="../../../assets/icon/adobe-icon.png" class="pdf-icon">
                          }
                          @if (!isImageFile(file) && !isPdfFile(file)) {
                            <span class="material-symbols-outlined" style="color:#A067E6">flip</span>
                          }
                        </div>
                        {{ file.name }}
                      </span>
                      <button class="delete-button" (click)="removeFile(file, $event)">
                        <span class="material-symbols-outlined">delete_forever</span>
                      </button>
                    </div>
                  }
                </div>
              }

              <input type="file" id="fileInput" hidden multiple (change)="onFileSelect($event)" #fileInput />
            </div>
          </div>

          @if (uploadedFiles.length > 0) {
            <div class="caja-botones">
              <button mat-stroked-button class="primary-button" [disabled]="uploadedFiles.length === 0"
                (click)="finalizarCargaMasiva()">
                Finalizar carga
              </button>
              <button mat-stroked-button class="secondary-button" (click)="fileInput.click()">Agregar más archivo</button>
            </div>
          }

          @if (uploadedFiles.length === 0) {
            <div class="caja-botones">
              <button mat-stroked-button class="primary-button" (click)="step = 1">
                Volver
              </button>
            </div>
          }

        </div>
      </mat-card-content>
    </mat-card>
  </div>
}

@if(step == 4){
  <div
    class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn step4-container">
    <div style="margin-top: 30px;">
    </div>

    <mat-card class="centerabsolute" style="max-width: 680px;">
      <mat-card-content>
        <div class="mat-container">
          <div class="imagen-final">
            <img src="../../assets/iconografia/Iconografia - legal.png" style="height: 160px !important;">
          </div>
          <div class="titulo-card" style="margin-top: 10px;">nuestra área legal está trabajando para agilizar la creación del contrato</div>
          <div class="subtitulo-card">Te notificaremos cuando esté todo preparado para iniciar el proceso de firma electrónica.</div>

          <div class="caja-botones">
            <button mat-stroked-button class="secondary-button" (click)="logout()">Cerrar sesión</button>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

    <div class="contact-container">
      <contact-container></contact-container>
    </div>

  </div>
}
}


</div>